import type { Definition } from '@exodus/dependency-types';

import type { FetchWithRequestInterceptor } from '@/background/adapters/fetch';
import type { CustomToken } from '@/types';

type Dependencies = {
  assetsModule: any;
  fetch: FetchWithRequestInterceptor;
};

const interceptSearchTokens = (url: string, init: RequestInit): RequestInit => {
  if (url !== 'https://ctr.a.exodus.io/registry/search' || !init.body) {
    return init;
  }

  const parsedBody = JSON.parse(init.body as string);
  const body = JSON.stringify({
    ...parsedBody,
    pageSize: 500,
  });

  return {
    ...init,
    body,
  };
};

const createCustomTokensApi = ({ assetsModule, fetch }: Dependencies) => {
  return {
    customTokens: {
      fetchToken: (...args) => assetsModule.fetchToken(...args),
      searchTokens: async (...args): Promise<CustomToken[]> => {
        fetch.setRequestInterceptor(interceptSearchTokens);
        const tokens = await assetsModule.searchTokens(...args);
        fetch.setRequestInterceptor(undefined);
        return tokens;
      },
    },
  };
};

const customTokensApiDefinition = {
  id: 'customTokensApi',
  type: 'api',
  factory: createCustomTokensApi,
  dependencies: [
    //
    'assetsModule',
    'fetch',
  ],
} as const satisfies Definition;

export default customTokensApiDefinition;
